import request from '@/config/request'

export default {
    registerCustomer: function (openId, mobile, userName,verifyCode,from,status) {
        return request({
            url: '/customer/customer/registercustomer',
            method: 'post',
            params: {
                openid: openId,
                mobile: mobile,
                username: userName,
                verifycode: verifyCode,
                from:from,
                status: status,
            }
        })
    },
    searchCustomer: function (code) {
        return request({
            url: '/customer/customer/searchcustomer',
            method: 'get',
            params: {
                code: code,
            }
        })
    },
    searchCustomerAssets: function (code) {
        return request({
            url: '/customer/customer/searchcustomerassets',
            method: 'get',
            params: {
                code: code,
            }
        })
    },
    logout: function (code) {
        return request({
            url: '/customer/customer/logout',
            method: 'get',
            params: {
                code: code,
            }
        })
    },
}



// WEBPACK FOOTER //
// ./src/api/customer/customer.js